import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { SimpleCookieService } from "./simple-cookie.service";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { COOKIE_STORAGE } from "../constants/cookie.constants";
import { LOCAL_STORAGE } from "../constants/local-storage.constants";
import { CustomerAddress, CustomerInput } from "../model/customer.model";
import {
	CREATE_CUSTOMER,
	GET_CUSTOMER_BY_ID,
	GET_CUSTOMER_BY_PHONE,
	REMOVE_PAYMENT_ID_FROM_CUSTOMER,
	UPDATE_CUSTOMER,
} from "../queries/customer.queries";
import { LocalStorageService } from "./local-storage.service";
import { SessionStorageService } from "./session-storage.service";
import { SESSION_STORAGE } from "../constants/session-storage.constants";

@Injectable({
	providedIn: "root",
})
export class CustomerService {
	private customer: BehaviorSubject<CustomerInput>;

	constructor(private cookie: SimpleCookieService, public apollo: Apollo) {
		let token = this.cookie.get(
			COOKIE_STORAGE.TOKEN,
			true,
			environment.COOKIE_KEY,
		);
		let userName;
		let userPhone;
		if (token && token !== "undefined") {
			userName = JSON.parse(token)?.additionalInfo?.name;
			userPhone = JSON.parse(token)?.username;
		} else {
			userName = "";
			userPhone = "";
		}

		let customer: CustomerInput = new CustomerInput(
			"",
			userName,
			userPhone,
			"",
			"",
			"",
			"",
			"",
			[],
		);
		this.customer = new BehaviorSubject<CustomerInput>(customer);
	}

	createCustomer(customer: CustomerInput) {
		return this.apollo.mutate({
			mutation: CREATE_CUSTOMER,
			variables: {
				customer: customer,
			},
		});
	}

	updateCustomer(id: string, customer: CustomerInput) {
		customer.address.forEach((add: CustomerAddress) => {
			if ("id" in add) {
				delete add.id;
			}
			if ("isNew" in add) {
				delete add.isNew;
			}
			return add;
		});
		return this.apollo.mutate({
			mutation: UPDATE_CUSTOMER,
			variables: {
				id: id,
				customer: customer,
			},
		});
	}

	removeCustomerIdFromCustomer(id: string) {
		return this.apollo.mutate({
			mutation: REMOVE_PAYMENT_ID_FROM_CUSTOMER,
			variables: {
				id: id,
			},
		});
	}

	getCustomerById(id: string) {
		return this.apollo.watchQuery({
			query: GET_CUSTOMER_BY_ID,
			variables: {
				id: id,
			},
		}).valueChanges;
	}

	getCustomerByPhone(phone: String) {
		return this.apollo.watchQuery({
			query: GET_CUSTOMER_BY_PHONE,
			variables: {
				phone: phone,
			},
			fetchPolicy: "network-only",
		}).valueChanges;
	}

	getCustomerAsObservable(): Observable<CustomerInput> {
		if (this.customer.value?.id.length === 0) {
			const rawCustomer = LocalStorageService.getValue(LOCAL_STORAGE.CUSTOMER_DETAILS);
			if (rawCustomer) {
				try {
					const customerObj = JSON.parse(rawCustomer) as CustomerInput;
					this.setCustomerDetails(customerObj);
				} catch {
					this.setCustomerDetails(new CustomerInput("", "", "", "", "", "", "", "", []));
				}
			}
		}

		return this.customer.asObservable();
	}

	setCustomerDetails(customer: CustomerInput) {
		LocalStorageService.setValue(
			LOCAL_STORAGE.CUSTOMER_ID,
			customer?.id ? customer?.id : "",
		);

		customer?.address.forEach((add) => {
			return (add.id = "id_" + Math.random().toString(16).slice(2));
		});

		this.customer.next(customer);
	}

	// processAddress(customer: CustomerInput): any {
	// 	let cust: any = ;

	// 	return cust;
	// }

	clearLocalStorage() {
		SessionStorageService.setValue(SESSION_STORAGE.ORDERID, "");
		SessionStorageService.setValue(SESSION_STORAGE.RESERVATION_DETAILS, "");
	}
}
